(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("StReportSdk", [], factory);
	else if(typeof exports === 'object')
		exports["StReportSdk"] = factory();
	else
		root["StReportSdk"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	var st_report_sdk_1 = __webpack_require__(1);
	module.exports = module.exports['default'] = st_report_sdk_1["default"];

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	    }
	    return t;
	};
	exports.__esModule = true;
	var queryString = __webpack_require__(2);
	// noinspection SpellCheckingInspection
	var uuidv4 = __webpack_require__(5);
	var events_1 = __webpack_require__(8);
	var get_utm_source_by_ua_1 = __webpack_require__(9);
	window.addEventListener('DOMContentLoaded', refresh, false);
	window.addEventListener('hashchange', refresh, false);
	var routeStartTime;
	function refresh() {
	    routeStartTime = +new Date();
	}
	var StReportSdk = /** @class */function () {
	    /**
	     * 构造函数
	     * @param {boolean} disableGetRequireQsFromUrl - 是否禁止通过 url 拉取所需的 query string 以用于后续上报
	     * @param {string[]} qsWhiteList -  query string  白名单
	     * @param {string} apiAddress 上报 API 地址
	     * @param {string} projectIdentifier 项目标识（[A-Za-z_]+{4,32},内部约定）
	     * @param [string[]] eventTags - 事件标签数组（格式与时间分组一致），可选
	     * @param {string} eventGroup - 事件分组（[A-Za-z_\-]+{1,},内部约定），可选
	     * @param {string} autoDetectUtmSource - 是否自动识别 utm_source, 当 utm_source 为 js false 时才使用
	     * @param {boolean} debug 是否启用调试模式
	     * @param {Function} beforeReport - 上报前拦截
	     */
	    function StReportSdk(_a) {
	        var _b = _a === void 0 ? {} : _a,
	            _c = _b.disableGetRequireQsFromUrl,
	            disableGetRequireQsFromUrl = _c === void 0 ? false : _c,
	            _d = _b.qsWhiteList,
	            qsWhiteList = _d === void 0 ? [] : _d,
	            apiAddress = _b.apiAddress,
	            projectIdentifier = _b.projectIdentifier,
	            eventTags = _b.eventTags,
	            eventGroup = _b.eventGroup,
	            _e = _b.autoDetectUtmSource,
	            autoDetectUtmSource = _e === void 0 ? true : _e,
	            beforeReport = _b.beforeReport,
	            _f = _b.debug,
	            debug = _f === void 0 ? false : _f;
	        this.disableGetRequireQsFromUrl = disableGetRequireQsFromUrl;
	        this.qsWhiteList = qsWhiteList;
	        this.apiAddress = apiAddress;
	        this.eventTags = eventTags;
	        this.eventGroup = eventGroup;
	        this.projectIdentifier = projectIdentifier;
	        this.autoDetectUtmSource = autoDetectUtmSource;
	        this.debug = debug;
	        this.beforeReport = beforeReport;
	    }
	    /**
	     * 获取默认实例
	     * @param {string} projectIdentifier - 项目唯一标识
	     * @param eventTags [string[]] - 事件标签数组（格式与时间分组一致），可选
	     * @param {boolean} [debug] - 是否启用调试模式
	     * @param {string} [eventGroup] - 事件分组（[A-Za-z_\-]+{1,},内部约定），可选
	     * @param {*} [restProps]
	     * @return {StReportSdk} - 返回当前实例
	     */
	    StReportSdk.getInstance = function (_a, debug) {
	        if (_a === void 0) {
	            _a = {};
	        }
	        if (debug === void 0) {
	            debug = false;
	        }
	        var projectIdentifier = _a.projectIdentifier,
	            eventTags = _a.eventTags,
	            eventGroup = _a.eventGroup,
	            restProps = __rest(_a, ["projectIdentifier", "eventTags", "eventGroup"]);
	        if (typeof arguments[0] === 'string') {
	            projectIdentifier = arguments[0];
	        }
	        return new StReportSdk(__assign(__assign(__assign({}, StReportSdk.defaultProps), { projectIdentifier: projectIdentifier,
	            eventTags: eventTags,
	            eventGroup: eventGroup,
	            debug: debug }), restProps));
	    };
	    /**
	     * 能够自动跟踪
	     */
	    StReportSdk.autoTrack = function (config) {
	        if (!config) {
	            // @ts-ignore
	            config = {
	                projectIdentifier: 'test',
	                eventGroup: 'test',
	                eventTags: []
	            };
	        }
	        if (config.projectIdentifier === 'test') {
	            // noinspection JSUnresolvedVariable
	            var url = (location.host + location.pathname).replace(/\/[^/.]+\.?html$/, '');
	            var identify = url.split('.')[0];
	            var validIdentifierList = ['jx3', 'jx3yq', 'daily', 'js3', 'js2', 'zjjh', 'jxsj2', 'jx', 'jx2', 'zzq', 'gcg2', 'cpol', 'jx3wbl', 'xoyo', 'sx'];
	            config.projectIdentifier = validIdentifierList.indexOf(identify) > -1 ? identify : 'xishanju_com';
	            var matches = url.match(/\/(\w+)\//);
	            config.eventTags = matches ? [matches[1]] : [];
	            // noinspection SpellCheckingInspection
	            config.eventGroup = url.replace('.xoyo.com', '').replace(/\/$/, '').replace(/[./-]/g, '_');
	        }
	        var stReportSdk = StReportSdk.getInstance(config);
	        var tracker = {
	            loadPage: function loadPage() {
	                stReportSdk.report({
	                    eventName: 'load_page_start',
	                    eventDescription: '页面加载 (默认上报，进入页面就上报)',
	                    eventDataValue: {
	                        td_pl: StReportSdk.getDiffRouteTime()
	                    }
	                });
	            }
	        };
	        var host = location.host;
	        var isXoyo = host.indexOf('.xoyo.com') > -1;
	        var isSeasungame = host.indexOf('.seasungame.com') > -1;
	        var isXiShanJu = host.indexOf('.xishanju.com') > -1;
	        var isXoyoGames = host.indexOf('.xoyo.games') > -1;
	        var isTestXoyo = host.indexOf('test-zt.xoyo.com') > -1;
	        if ((isXoyo || isSeasungame || isXiShanJu || isXoyoGames) && !isTestXoyo) {
	            tracker.loadPage();
	            stReportSdk.trackPageLoad();
	            stReportSdk.trackPageLeave();
	        }
	    };
	    /**
	     * 获取 page view id
	     * @return {string}
	     */
	    StReportSdk.getPageViewId = function () {
	        var uid = StReportSdk.pageViewCache.uid;
	        if (!uid) {
	            StReportSdk.pageViewCache = {
	                currentUrl: location.href,
	                uid: uuidv4()
	            };
	        }
	        return StReportSdk.pageViewCache.uid;
	    };
	    /**
	     * 上报
	     * @param projectIdentifier [string] - 项目标识（[A-Za-z_]+{4, },内部约定），必选
	     * @param eventName [string] - 事件名称，（格式与时间分组一致），可选
	     * @param eventGroup [string] - 事件分组（[A-Za-z_\-]+{1,},内部约定），可选
	     * @param eventDescription [string]- 事件描述（字符串）
	     * @param eventDataValue [object] - 事件额外数据对象，kv对，可选, 如: evd[k1]=v1&evd[k2]
	     * @param eventTags [string[]] - 事件标签数组（格式与时间分组一致），可选
	     * @param referer {string} - 事件标签数组（格式与时间分组一致），可选
	     * @param {Function} beforeReport - 上报前拦截
	     * @param shouldSendBeacon {boolean} - 是否以 navigator.sendBeacon 的形式发送请求
	     */
	    StReportSdk.prototype.report = function (_a) {
	        var _b = _a === void 0 ? {} : _a,
	            projectIdentifier = _b.projectIdentifier,
	            eventName = _b.eventName,
	            eventGroup = _b.eventGroup,
	            eventDescription = _b.eventDescription,
	            eventDataValue = _b.eventDataValue,
	            _c = _b.eventTags,
	            eventTags = _c === void 0 ? [] : _c,
	            referer = _b.referer,
	            _d = _b.beforeReport,
	            beforeReport = _d === void 0 ? this.beforeReport : _d,
	            shouldSendBeacon = _b.shouldSendBeacon;
	        var whiteListLocationSearchObject = this.disableGetRequireQsFromUrl ? {} : this.getWhiteListLocationSearchObject();
	        var apiAddress = this.apiAddress;
	        var p = projectIdentifier || this.projectIdentifier;
	        if (eventGroup && typeof eventGroup !== 'string') {
	            throw new Error('事件分组 event group 必须为 string 类型');
	        }
	        var latestUtmSource = this.getLatestUrlUtmSource();
	        var ev_g = eventGroup || this.eventGroup;
	        var ev_desc = eventDescription;
	        var ev_d = eventDataValue;
	        var ev_n = eventName;
	        var ev_tag = Array.isArray(eventTags) && eventTags.length ? eventTags : this.eventTags;
	        var pv_id = StReportSdk.getPageViewId();
	        var prev_ref = document.referrer;
	        var full_ref = window.location.href;
	        var customRequestParams = __assign(__assign({ p: p, ev_g: ev_g, ev_desc: ev_desc, ev_d: ev_d, ev_n: ev_n, ev_tag: ev_tag, pv_id: pv_id, prev_ref: prev_ref, full_ref: full_ref }, StReportSdk.getDeviceSize()), { latest_utm_source: latestUtmSource });
	        var requestParams = _extends(customRequestParams, whiteListLocationSearchObject);
	        if (beforeReport) {
	            requestParams = beforeReport(requestParams);
	        }
	        var requestParamString = StReportSdk.convertObjectToRequestParams(requestParams);
	        var finalRequestUrl = apiAddress + "?" + encodeURIComponent(requestParamString);
	        this.debugLog("report custom request params: ", customRequestParams);
	        this.debugLog("report white list location search object: ", whiteListLocationSearchObject);
	        this.debugLog("report request params: ", requestParams);
	        this.debugLog("report api address: ", apiAddress);
	        // this.debugLog(`report final request url: `, finalRequestUrl); 没有人关注最后的链接
	        if (StReportSdk.isSendBeaconSupported() && shouldSendBeacon) {
	            StReportSdk.reportRequestViaBeacon(finalRequestUrl);
	        } else {
	            StReportSdk.reportRequestViaImage(finalRequestUrl);
	        }
	    };
	    /**
	     * 获取设备宽高
	     * @return {object} e.g. {ua_cw: 1920, ua_ch: 1080, ua_cwh: "1920x1080", ua_cdr: "16:9", ua_co: "landscape"}
	     */
	    StReportSdk.getDeviceSize = function () {
	        var innerWidth = window.innerWidth || 0;
	        var innerHeight = window.innerHeight || 0;
	        return {
	            // 设备实际屏幕宽度:ua_cw(client width)  整型 例如 1440 ，没有上报默认0  （整型方便做数值运算类的统计，例如分辨率大于多少XXX）
	            ua_cw: innerWidth,
	            // 设备实际屏幕高度:ua_ch(client height) 整型 例如 900，没有上报默认0
	            ua_ch: innerHeight,
	            // 设备实际屏幕宽度x设备屏幕高度:ua_cwh 字符串，例如：“1440x900” ，没有上报默认 "0x0" （这个可以做聚合）
	            ua_cwh: innerWidth + "x" + innerHeight,
	            // 设备屏幕宽高:ua_device_cwh(client device width height) 例如：“1440x900” ，没有上报默认 "0x0" （这个可以做聚合）
	            ua_device_cwh: window.screen.width + "x" + window.screen.height,
	            // 设备屏幕宽高比例: ua_device_csr(client device screen ratio) 设备比例, 以9为基数计算 (如: 9:16)
	            ua_device_csr: StReportSdk.getScreenRatioArr(window.screen.width, window.screen.height).join(':'),
	            // ua_cdr(client screen ratio) 设备比例, 以9为基数计算 (如: 9:16)
	            ua_csr: StReportSdk.getScreenRatioArr(innerWidth, innerHeight).join(':'),
	            // ua client orientation 设备横竖屏方向
	            ua_co: window.innerHeight > window.innerWidth ? 'portrait' : 'landscape'
	        };
	    };
	    /**
	     * 获取屏幕比例
	     * @param {number} width - 长度
	     * @param {number} height - 高度
	     */
	    StReportSdk.getScreenRatioArr = function (width, height) {
	        if (!width || !height) {
	            return [width, height];
	        }
	        var biggerValue = Math.max(width, height);
	        var smallerValue = Math.min(width, height);
	        var clientDeviceRatioArr = [9, Number((biggerValue / smallerValue * 9).toFixed(2))];
	        if (width > height) {
	            clientDeviceRatioArr.reverse();
	        }
	        return clientDeviceRatioArr;
	    };
	    /**
	     * 追踪点击事件。
	     * trackClick('ViewProduct');
	     * @param eventName {string} - 必选。表示要追踪的事件名。
	     * @param properties {object} - 可选。为了保证统一接口，properties可选填，但对于百度统计无效。
	     */
	    StReportSdk.prototype.trackClick = function (eventName, properties) {
	        this.report({ eventName: eventName, eventDataValue: properties });
	    };
	    /**
	     * 页面载入上报共用方法
	     * @param extra
	     */
	    StReportSdk.prototype.pageLoad = function (extra) {
	        if (extra === void 0) {
	            extra = {};
	        }
	        var _a = extra.eventDataValue,
	            eventDataValue = _a === void 0 ? {} : _a,
	            restProps = __rest(extra, ["eventDataValue"]);
	        eventDataValue = _extends(eventDataValue, { td_pl: StReportSdk.getDiffRouteTime(), ts: +new Date() });
	        this.report(__assign({ eventName: 'load_page', eventDataValue: eventDataValue }, restProps));
	    };
	    /**
	     * 页面载入上报共用方法
	     * @param extra
	     */
	    StReportSdk.prototype.pageLeave = function (extra) {
	        if (extra === void 0) {
	            extra = {};
	        }
	        var _a = extra.eventDataValue,
	            eventDataValue = _a === void 0 ? {} : _a,
	            restProps = __rest(extra, ["eventDataValue"]);
	        eventDataValue = _extends(eventDataValue, { td_pl: StReportSdk.getDiffRouteTime(), ts: +new Date() });
	        this.report(__assign({ eventName: 'page_leave', shouldSendBeacon: true, eventDataValue: eventDataValue }, restProps));
	    };
	    /**
	     * 跟踪页面初始化时候上报 用于记录PV
	     */
	    StReportSdk.prototype.trackPageLoad = function (extra) {
	        var _this = this;
	        if (extra === void 0) {
	            extra = {};
	        }
	        events_1["default"]('load', function () {
	            _this.pageLoad(extra);
	        });
	    };
	    /**
	     * 跟踪页面离开
	     */
	    StReportSdk.prototype.trackPageLeave = function (extra) {
	        var _this = this;
	        if (extra === void 0) {
	            extra = {};
	        }
	        window.addEventListener('beforeunload', function () {
	            _this.pageLeave(extra);
	        }, true);
	    };
	    /**
	     * 当react或vue路由切换页面时上报
	     */
	    StReportSdk.prototype.trackRoutePageLoad = function (extra) {
	        this.pageLoad(extra);
	    };
	    /**
	     * 计算 route 时间差异
	     */
	    StReportSdk.getDiffRouteTime = function () {
	        if (routeStartTime) {
	            return +new Date() - routeStartTime;
	        } else {
	            return 0;
	        }
	    };
	    /**
	     * 根据当前白名单过滤获取 Location Search Object
	     * @return {ILocationObject}
	     */
	    StReportSdk.prototype.getWhiteListLocationSearchObject = function () {
	        var qsWhiteList = this.qsWhiteList;
	        var locationSearchObject = StReportSdk.getLocationSearchObject();
	        if (this.autoDetectUtmSource) {
	            if (!locationSearchObject['utm_source']) {
	                locationSearchObject['utm_source'] = get_utm_source_by_ua_1["default"]();
	            }
	        }
	        return Object.keys(locationSearchObject).reduce(function (result, key) {
	            if (qsWhiteList.indexOf(key) > -1) {
	                result[key] = locationSearchObject[key];
	            }
	            return result;
	        }, {});
	    };
	    /**
	     * 移除对象中 undefined 的属性
	     * @private
	     * @param {object} obj - 任意 js 对象
	     */
	    StReportSdk.removeObjectUndefinedProps = function (obj) {
	        var result = {};
	        for (var key in obj) {
	            if (obj.hasOwnProperty(key) && obj[key] !== undefined) {
	                result[key] = obj[key];
	            }
	        }
	        return result;
	    };
	    /**
	     * 调试log
	     * @param {string} message
	     * @param {*} extraMessage
	     */
	    StReportSdk.prototype.debugLog = function (message, extraMessage) {
	        if (this.debug) {
	            var PREFIX = 'st-report-sdk: ';
	            try {
	                if ((typeof extraMessage === "undefined" ? "undefined" : _typeof(extraMessage)) === 'object') {
	                    console.log("" + PREFIX + message);
	                    console.table(StReportSdk.removeObjectUndefinedProps(extraMessage));
	                } else {
	                    console.log("" + PREFIX + message, extraMessage);
	                }
	            } catch (e) {
	                console.log("" + PREFIX + message, extraMessage);
	            }
	        }
	    };
	    /**
	     * 获取 location.search 中 query string 对象
	     * 输入: "?foo=bar"
	     * 输出 {foo: 'bar'}
	     * @return {ILocationObject}
	     */
	    StReportSdk.getLocationSearchObject = function (search) {
	        if (search === void 0) {
	            search = window.location.search;
	        }
	        return queryString.parse(search);
	    };
	    /**
	     * 将请求对象转换
	     * @param obj
	     * @return {string}
	     */
	    StReportSdk.convertObjectToRequestParams = function (obj) {
	        return JSON.stringify(obj);
	    };
	    /**
	     * 判断 navigator.sendBeacon 是否被当前浏览器支持
	     */
	    StReportSdk.isSendBeaconSupported = function () {
	        return navigator && navigator.sendBeacon;
	    };
	    /**
	     * 通过"图片请求"上报请求
	     * @private
	     * @param {string} requestUrl
	     */
	    StReportSdk.reportRequestViaImage = function (requestUrl) {
	        new Image().src = requestUrl;
	    };
	    /**
	     * get last url utm source
	     * @private
	     */
	    StReportSdk.prototype.getLatestUrlUtmSource = function () {
	        try {
	            var locationSearchObject = StReportSdk.getLocationSearchObject();
	            if (locationSearchObject && locationSearchObject.utm_source) {
	                return locationSearchObject.utm_source;
	            }
	            var latestSearchObject = StReportSdk.getLocationSearchObject(document.referrer);
	            if (latestSearchObject && latestSearchObject.utm_source) {
	                return latestSearchObject.utm_source;
	            }
	            return undefined;
	        } catch (e) {
	            return undefined;
	        }
	    };
	    /**
	     * 通过"navigator.sendBeacon请求"上报请求
	     * @private
	     * @param {string} requestUrl
	     */
	    StReportSdk.reportRequestViaBeacon = function (requestUrl) {
	        navigator.sendBeacon(requestUrl);
	    };
	    /**
	     * 默认 props
	     */
	    StReportSdk.defaultProps = {
	        qsWhiteList: ['utm_source', 'utm_medium', 'utm_term', 'utm_content', 'utm_campaign'],
	        apiAddress: '//st.xoyo.com/report/web'
	    };
	    /**
	     * 单例值, 用于存储 url 和 uid,
	     * 请勿直接使用该变量, 请使用 getPageViewId 访问内部值
	     * @type {IPageViewCache}
	     */
	    StReportSdk.pageViewCache = {};
	    return StReportSdk;
	}();
	exports["default"] = StReportSdk;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var strictUriEncode = __webpack_require__(3);
	var decodeComponent = __webpack_require__(4);
	function encoderForArrayFormat(options) {
	    switch (options.arrayFormat) {
	        case 'index':
	            return function (key, value, index) {
	                return value === null ? [encode(key, options), '[', index, ']'].join('') : [encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('');
	            };
	        case 'bracket':
	            return function (key, value) {
	                return value === null ? [encode(key, options), '[]'].join('') : [encode(key, options), '[]=', encode(value, options)].join('');
	            };
	        default:
	            return function (key, value) {
	                return value === null ? encode(key, options) : [encode(key, options), '=', encode(value, options)].join('');
	            };
	    }
	}
	function parserForArrayFormat(options) {
	    var result;
	    switch (options.arrayFormat) {
	        case 'index':
	            return function (key, value, accumulator) {
	                result = /\[(\d*)\]$/.exec(key);
	                key = key.replace(/\[\d*\]$/, '');
	                if (!result) {
	                    accumulator[key] = value;
	                    return;
	                }
	                if (accumulator[key] === undefined) {
	                    accumulator[key] = {};
	                }
	                accumulator[key][result[1]] = value;
	            };
	        case 'bracket':
	            return function (key, value, accumulator) {
	                result = /(\[\])$/.exec(key);
	                key = key.replace(/\[\]$/, '');
	                if (!result) {
	                    accumulator[key] = value;
	                    return;
	                }
	                if (accumulator[key] === undefined) {
	                    accumulator[key] = [value];
	                    return;
	                }
	                accumulator[key] = [].concat(accumulator[key], value);
	            };
	        default:
	            return function (key, value, accumulator) {
	                if (accumulator[key] === undefined) {
	                    accumulator[key] = value;
	                    return;
	                }
	                accumulator[key] = [].concat(accumulator[key], value);
	            };
	    }
	}
	function encode(value, options) {
	    if (options.encode) {
	        return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	    }
	    return value;
	}
	function decode(value, options) {
	    if (options.decode) {
	        return decodeComponent(value);
	    }
	    return value;
	}
	function keysSorter(input) {
	    if (Array.isArray(input)) {
	        return input.sort();
	    }
	    if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object') {
	        return keysSorter(Object.keys(input)).sort(function (a, b) {
	            return Number(a) - Number(b);
	        }).map(function (key) {
	            return input[key];
	        });
	    }
	    return input;
	}
	function extract(input) {
	    var queryStart = input.indexOf('?');
	    if (queryStart === -1) {
	        return '';
	    }
	    return input.slice(queryStart + 1);
	}
	function parse(input, options) {
	    options = _extends({ decode: true, arrayFormat: 'none' }, options);
	    var formatter = parserForArrayFormat(options);
	    // Create an object with no prototype
	    var ret = Object.create(null);
	    if (typeof input !== 'string') {
	        return ret;
	    }
	    input = input.trim().replace(/^[?#&]/, '');
	    if (!input) {
	        return ret;
	    }
	    for (var _i = 0, _a = input.split('&'); _i < _a.length; _i++) {
	        var param = _a[_i];
	        var _b = param.replace(/\+/g, ' ').split('='),
	            key = _b[0],
	            value = _b[1];
	        // Missing `=` should be `null`:
	        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
	        value = value === undefined ? null : decode(value, options);
	        formatter(decode(key, options), value, ret);
	    }
	    return Object.keys(ret).sort().reduce(function (result, key) {
	        var value = ret[key];
	        if (Boolean(value) && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !Array.isArray(value)) {
	            // Sort object keys, not values
	            result[key] = keysSorter(value);
	        } else {
	            result[key] = value;
	        }
	        return result;
	    }, Object.create(null));
	}
	exports.extract = extract;
	exports.parse = parse;
	exports.stringify = function (obj, options) {
	    var defaults = {
	        encode: true,
	        strict: true,
	        arrayFormat: 'none'
	    };
	    options = _extends(defaults, options);
	    if (options.sort === false) {
	        options.sort = function () {};
	    }
	    var formatter = encoderForArrayFormat(options);
	    return obj ? Object.keys(obj).sort(options.sort).map(function (key) {
	        var value = obj[key];
	        if (value === undefined) {
	            return '';
	        }
	        if (value === null) {
	            return encode(key, options);
	        }
	        if (Array.isArray(value)) {
	            var result = [];
	            for (var _i = 0, _a = value.slice(); _i < _a.length; _i++) {
	                var value2 = _a[_i];
	                if (value2 === undefined) {
	                    continue;
	                }
	                result.push(formatter(key, value2, result.length));
	            }
	            return result.join('&');
	        }
	        return encode(key, options) + '=' + encode(value, options);
	    }).filter(function (x) {
	        return x.length > 0;
	    }).join('&') : '';
	};
	exports.parseUrl = function (input, options) {
	    return {
	        url: input.split('?')[0] || '',
	        query: parse(extract(input), options)
	    };
	};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function (str) {
	  return encodeURIComponent(str).replace(/[!'()*]/g, function (x) {
	    return "%" + x.charCodeAt(0).toString(16).toUpperCase();
	  });
	};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var token = '%[a-f0-9]{2}';
	var singleMatcher = new RegExp(token, 'gi');
	var multiMatcher = new RegExp('(' + token + ')+', 'gi');
	function decodeComponents(components, split) {
	    try {
	        // Try to decode the entire string first
	        return decodeURIComponent(components.join(''));
	    } catch (err) {
	        // Do nothing
	    }
	    if (components.length === 1) {
	        return components;
	    }
	    split = split || 1;
	    // Split the array in 2 parts
	    var left = components.slice(0, split);
	    var right = components.slice(split);
	    return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
	}
	function decode(input) {
	    try {
	        return decodeURIComponent(input);
	    } catch (err) {
	        var tokens = input.match(singleMatcher);
	        for (var i = 1; i < tokens.length; i++) {
	            input = decodeComponents(tokens, i).join('');
	            tokens = input.match(singleMatcher);
	        }
	        return input;
	    }
	}
	function customDecodeURIComponent(input) {
	    // Keep track of all the replacements and prefill the map with the `BOM`
	    var replaceMap = {
	        '%FE%FF': '\uFFFD\uFFFD',
	        '%FF%FE': '\uFFFD\uFFFD'
	    };
	    var match = multiMatcher.exec(input);
	    while (match) {
	        try {
	            // Decode as big chunks as possible
	            replaceMap[match[0]] = decodeURIComponent(match[0]);
	        } catch (err) {
	            var result = decode(match[0]);
	            if (result !== match[0]) {
	                replaceMap[match[0]] = result;
	            }
	        }
	        match = multiMatcher.exec(input);
	    }
	    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	    replaceMap['%C2'] = '\uFFFD';
	    var entries = Object.keys(replaceMap);
	    for (var i = 0; i < entries.length; i++) {
	        // Replace all decoded components
	        var key = entries[i];
	        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	    }
	    return input;
	}
	module.exports = function (encodedURI) {
	    if (typeof encodedURI !== 'string') {
	        throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + (typeof encodedURI === 'undefined' ? 'undefined' : _typeof(encodedURI)) + '`');
	    }
	    try {
	        encodedURI = encodedURI.replace(/\+/g, ' ');
	        // Try the built in decoder first
	        return decodeURIComponent(encodedURI);
	    } catch (err) {
	        // Fallback to a more advanced decoder
	        return customDecodeURIComponent(encodedURI);
	    }
	};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var rng = __webpack_require__(6);
	var bytesToUuid = __webpack_require__(7);
	function v4(options, buf, offset) {
	    var i = buf && offset || 0;
	    if (typeof options == 'string') {
	        buf = options === 'binary' ? new Array(16) : null;
	        options = null;
	    }
	    options = options || {};
	    var rnds = options.random || (options.rng || rng)();
	    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	    rnds[6] = rnds[6] & 0x0f | 0x40;
	    rnds[8] = rnds[8] & 0x3f | 0x80;
	    // Copy bytes to buffer, if provided
	    if (buf) {
	        for (var ii = 0; ii < 16; ++ii) {
	            buf[i + ii] = rnds[ii];
	        }
	    }
	    return buf || bytesToUuid(rnds);
	}
	module.exports = v4;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
	var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && msCrypto.getRandomValues.bind(msCrypto);
	if (getRandomValues) {
	    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	    var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	    module.exports = function whatwgRNG() {
	        getRandomValues(rnds8);
	        return rnds8;
	    };
	} else {
	    // Math.random()-based (RNG)
	    //
	    // If all else fails, use Math.random().  It's fast, but is of unspecified
	    // quality.
	    var rnds = new Array(16);
	    module.exports = function mathRNG() {
	        for (var i = 0, r; i < 16; i++) {
	            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	            rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	        }
	        return rnds;
	    };
	}

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	    byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	function bytesToUuid(buf, offset) {
	    var i = offset || 0;
	    var bth = byteToHex;
	    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
	}
	module.exports = bytesToUuid;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function register(type, fn) {
	    if (window.attachEvent) {
	        window['e' + type + fn] = fn;
	        window[type + fn] = function () {
	            window['e' + type + fn](window.event);
	        };
	        window.attachEvent('on' + type, window[type + fn]);
	    } else {
	        window.addEventListener(type, fn, false);
	    }
	}
	exports["default"] = register;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	var deviceUtils = __webpack_require__(10);
	/**
	 * 通过 user agent 获取对应 utm_source
	 */
	function getUtmSourceByUA() {
	    if (deviceUtils.isJianghuDaily()) {
	        return 'daily';
	    } else if (deviceUtils.isWeiXin()) {
	        return 'wx';
	    } else if (deviceUtils.isMWeibo()) {
	        return 'wb';
	    } else if (deviceUtils.isMQQ()) {
	        return 'qq';
	    }
	    return undefined;
	}
	exports["default"] = getUtmSourceByUA;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	/**
	 * 获取 UA
	 * @return {string}
	 */
	function getUserAgent() {
	    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	    return userAgent.toLowerCase();
	}
	/**
	 * 判断是否是手机
	 * @return {boolean}
	 */
	function isMobile() {
	    var userAgent = getUserAgent();
	    return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series([46])0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) ||
	        // eslint-disable-next-line
	        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br([ev])w|bumb|bw-([nu])|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do([cp])o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly([-_])|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-([mpt])|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c([- _agpst])|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac([ -\/])|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja([tv])a|jbro|jemu|jigs|kddi|keji|kgt([ \/])|klon|kpt |kwc-|kyo([ck])|le(no|xi)|lg( g|\/([klu])|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t([- ov])|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok([6i])|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c([-01])|47|mc|nd|ri)|sgh-|shar|sie([-m])|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel([im])|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c([- ])|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(userAgent.substr(0, 4))
	    );
	}
	/**
	 * 判断是否是 android 设备
	 * @return {boolean}
	 */
	function isAndroid() {
	    return (/android/i.test(getUserAgent())
	    );
	}
	/**
	 * 判断是否 ios 设备
	 * @return {boolean}
	 */
	function isIOS() {
	    return (/iPad|iPhone|iPod/i.test(getUserAgent()) && !window.MSStream
	    );
	}
	/**
	 * 是否是 微信 设备
	 * @return {boolean}
	 */
	function isWeiXin() {
	    var userAgent = getUserAgent();
	    return String(userAgent.match(/MicroMessenger/i)) === 'micromessenger';
	}
	/**
	 * 判断是否是 mobile 微信
	 * @return {boolean}
	 */
	function isMWeiXin() {
	    return isMobile() && isWeiXin();
	}
	/**
	 * 判断是否是手机qq
	 * @return {boolean}
	 */
	function isMQQ() {
	    var userAgent = getUserAgent();
	    var isIOSQQ = isIOS() && / QQ/i.test(userAgent);
	    var isAndroidQQ = isAndroid() && /MQQBrowser/i.test(navigator.userAgent) && /QQ/i.test(userAgent.split('mqqbrowser'));
	    return isMobile() && (isIOSQQ || isAndroidQQ);
	}
	/**
	 * 判断是否是手机微博 UA
	 * @return {boolean}
	 */
	function isMWeibo() {
	    var userAgent = getUserAgent();
	    return isMobile() && /(weibo)/.test(userAgent);
	}
	/**
	 * 判断是否是江湖 daily App
	 */
	function isJianghuDaily() {
	    var userAgent = getUserAgent();
	    return (/jianghudaily/i.test(userAgent)
	    );
	}
	exports.getUserAgent = getUserAgent;
	exports.isMobile = isMobile;
	exports.isAndroid = isAndroid;
	exports.isIOS = isIOS;
	exports.isWeiXin = isWeiXin;
	exports.isMWeiXin = isMWeiXin;
	exports.isMQQ = isMQQ;
	exports.isMWeibo = isMWeibo;
	exports.isJianghuDaily = isJianghuDaily;

/***/ })
/******/ ])
});
;
//# sourceMappingURL=st-report-sdk.js.map